<script>
import Alert from './alert';
export default {
  name: 'OPCAlert',
  components: { Alert },
  props: {
    type: String
  },
  methods: {
    getIconSlots() {
      return {
        warning: <img slot="icon" src={require('@/assets/Alert.svg')} alt="" />,
        info: <img slot="icon" src={require("@/assets/Info.svg")} alt="" />,
        success: <i slot="icon" aria-hidden="" class="zm-icon-success"></i>
      }[this.type];
    },
  },
  render() {
    return (
      <alert class="opc-alert" {...{ props: { ...this.$props, ...this.$attrs }}}>
        {this.$slots.icon || this.getIconSlots()}
        {this.$slots.default}
      </alert>
    );
  },
};
</script>
